<template>
  <div>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>日期</th>
        <th>說明</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td class="text-center" width="120px">
<!--          <a class="btn btn-primary" @click="DataItem_Insert(item)"><i class="fas fa-plus-circle"></i> </a>-->
<!--          <a class="btn btn-danger" @click="DataItem_Remove(item)"><i class="far fa-trash-alt">  </i></a>-->
<!--          <a class="btn btn-primary" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i>  </a>-->
<!--          <a class="btn btn-primary" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i>  </a>-->
        </td>
        <td width="120px">
          {{item.date}}
        </td>
        <td >
          {{item.desc}}
        </td>
      </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
/**

 **/
import arrayUtil from "../../../util/arrayUtil";
import util from "../../../util/util";


export default {
  //name: "showData",
  props: ["datas"],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
    };
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },

    submit(){
      for (let i = 0; i < this.datas.Details.length; i++) {
        let item = this.datas.Details[i];

        if (item.Year===""){
          util.showErrorMessage("第"+i+1+" 行，「年」為必填欄位")
          return;
        }
        if (item.Month===""){
          util.showErrorMessage("第"+i+1+" 行，「月」為必填欄位")
          return;
        }
        if (item.Type===""){
          util.showErrorMessage("第"+i+1+" 行，「幣別」為必填欄位")
          return;
        }
        if (item.Rate===""){
          util.showErrorMessage("第"+i+1+" 行，「匯率」為必填欄位")
          return;
        }
      }

      // apiGPK.api_Save_datas(this.datas.SystemId,"",this.datas).then((data)=>{
      //   util.ShowMessage('儲存成功')
      // })
    },

    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.Id,this.datas,"Id","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.Id,this.datas,"Id","OrderKey")
    },
    DataItem_AddLast(){
      let newItem={
        Id:util.uuid(),
        Year:0,
        Moneth:0,
        Type:"",
        Rate:0,
        OrderKey:0,
      }

      arrayUtil.orderAppendLast(newItem,this.datas,"OrderKey")
    },
    DataItem_Insert(currentItem){
      let newItem={
        Id:util.uuid(),
        Year:0,
        Moneth:0,
        Type:"",
        Rate:0,
        OrderKey:0,
      }

      arrayUtil.orderInsert(newItem,currentItem,this.datas,"Id","OrderKey")
    },
    DataItem_Remove(item){
      arrayUtil.removeByPredicate(this.datas,s => s.Id===item.Id);
    },




  },
  mounted() {
    //this.loadData()
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
